import React from 'react';
import PropTypes from 'prop-types';
import '../css/index.css';

const BoxComponent = ({ backgroundColor, image, title, subtitle, onPress, isLoadMyAgent}) => {
  return (
    <div
      className={isLoadMyAgent?"box-component-load-my-Agent":"box-component"}
      style={{ background: backgroundColor || '#fff' }}
      onClick={onPress} // Add onClick or onPress handler to the container
    >
      <div className="box-content">
        <h3 className="box-title">{title}</h3>
        <p className="box-subtitle">{subtitle}</p>
      </div>
      {image && <img src={image} alt={title} className="box-image" />}
    </div>
  );
};


// Prop validation
BoxComponent.propTypes = {
  backgroundColor: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  isLoadMyAgent: PropTypes.bool.isRequired
};

export default BoxComponent;
